module.exports = {"id":"192708","name":"Carlos Eduardo","rating":"77","photo":"./data/images/photos/3/192708.png","club":{"name":"Al Hilal","logo":"./data/images/clubs/AlHilal.png"},"positions":["ATT","MOC","BU","MD"],"photoFolderIndex":3}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/CarlosEduardo0.json
// module id = 715
// module chunks = 0